import { Badge } from '@chakra-ui/react';

export type StatusAula = 'AGENDADA' | 'PENDENTE' | 'INICIADA' | 'CONCLUIDA' | 'CANCELADA';

/**
 * Rótulo e cor de cada status, num lugar só: o painel do admin, a tela do
 * professor, o portal do aluno e os gráficos mostravam o enum cru da API
 * ("CONCLUIDA", sem acento) e pintavam de laranja tudo o que não era concluída,
 * inclusive a aula cancelada.
 */
const STATUS_AULA: Record<StatusAula, { rotulo: string; cor: string }> = {
	AGENDADA: { rotulo: 'Agendada', cor: 'blue' },
	PENDENTE: { rotulo: 'Pendente', cor: 'orange' },
	INICIADA: { rotulo: 'Iniciada', cor: 'purple' },
	CONCLUIDA: { rotulo: 'Concluída', cor: 'green' },
	CANCELADA: { rotulo: 'Cancelada', cor: 'gray' }
};

/** Status que a API mande e esta tabela não conheça aparece como veio, em cinza. */
export const rotuloStatusAula = (status: string) =>
	STATUS_AULA[status as StatusAula]?.rotulo ?? status;

export const StatusAulaBadge = ({ status }: { status: string }) => (
	<Badge colorScheme={STATUS_AULA[status as StatusAula]?.cor ?? 'gray'}>
		{rotuloStatusAula(status)}
	</Badge>
);
